<template>
  <div
    v-if="!lazy || loaded || active"
    v-show="active"
    :id="`pane-${paneName}`"
    ref="tabPaneRef"
    class="el-tab-pane cube-tab-pane tab-pane-container flexV"
    :class="{ fixed: !fixed }"
    role="tabpanel"
    :aria-hidden="!active"
    :aria-labelledby="`tab-${paneName}`"
  >
    <div v-show="showHeader_" class="tab-pane-header">
      <div
        class="header-content flexCB"
        :class="headerBorder ? 'border-bottom' : ''"
      >
        <!-- 单独标题 -->
        <div v-if="title" class="tab-pane-title">
          {{ title }}
        </div>
        <!-- 自定义标题 -->
        <div v-else>
          <slot name="tab-pane-title" />
        </div>
        <!-- 按钮 -->
        <div ref="tabPaneBtnRef" class="tab-pane-btn">
          <slot name="tab-pane-btn" />
        </div>
      </div>
    </div>
    <div class="tab-pane-content" :style="paneContentStyle_">
      <!-- <div class="tab-pane-header" v-if="showHeader_ && !fixed"></div> -->
      <slot />
    </div>
  </div>
</template>
<script>
import '../../../../lib/styles/components/TabPane.scss'
export default {
  name: 'TabPane',
  componentName: 'TabPane',
  props: {
    label: String,
    labelContent: Function,
    name: String,
    closable: Boolean,
    disabled: Boolean,
    lazy: Boolean,
    title: {
      type: String,
      default: ''
    },
    fixed: {
      type: Boolean,
      default: true
    },
    headerBorder: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      index: null,
      loaded: false,
      slot: [],
      paneBtnVisible: true,
      observer: null
    }
  },
  computed: {
    // 默认插槽值为空的时候无padding
    paneContentStyle_() {
      if (!this.slot['default']) {
        return {
          paddingBottom: 0
        }
      }
      return {}
    },
    isClosable() {
      return this.closable || this.$parent.closable
    },
    active() {
      const active = this.$parent.currentName === (this.name || this.index)
      if (active) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.loaded = true
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.slot = this.$slots
      }
      return active
    },
    paneName() {
      return this.name || this.index
    },
    showHeader_() {
      return (
        this.title ||
        this.slot['tab-pane-title'] ||
        (this.slot['tab-pane-btn'] && this.paneBtnVisible)
      )
    },
    paneHeaderStyle_() {
      if (this.fixed) {
        return { position: 'absolute' }
      }
      return {}
    }
  },
  mounted() {
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.target.classList.contains('tab-pane-header')
        ) {
          if (mutation.target.style.display !== 'none' && !this.showHeader_) {
            mutation.target.style.display = 'none'
          }
        } else {
          this.setPaneBtnVisible()
        }
      })
    })

    if (this.$refs.tabPaneRef) {
      this.observer.observe(this.$refs.tabPaneRef, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      })
    }

    this.setPaneBtnVisible()
  },
  beforeDestroy() {
    this.observer?.disconnect()
  },
  updated() {
    this.$parent.$emit('tab-nav-update')
  },
  methods: {
    setPaneBtnVisible() {
      this.paneBtnVisible = !!this.$refs?.tabPaneBtnRef?.innerText
    }
  }
}
</script>
